module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "circle"
  }, [_c('div', {
    staticClass: "dot dot1"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot dot2"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot dot3"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot dot4"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot dot5"
  })]), _vm._v(" "), _c('img', {
    staticClass: "loader-image",
    attrs: {
      "src": "assets/pridel-favicon.png",
      "alt": "Loader"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e5e3a5e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/customLoader.vue
// module id = 2616
// module chunks = 0